import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  projectDetails: {
    pname: '',
    pdesc: '',
    pfirm: '',
    pbudget: '',
    penddate: null
  }
}

const createProjectState = createSlice({
  name: 'createProjectState',
  initialState,
  reducers: {
    setProjectDetails: (state, action) => {
      state.projectDetails = { ...state.projectDetails, ...action.payload }
    },
    clearProjectDetails: (state) => {
      state.projectDetails = {
        pname: '',
        pdesc: '',
        pfirm: '',
        pbudget: '',
        penddate: null
      }
    }
  }
})

export const { setProjectDetails, clearProjectDetails } = createProjectState.actions
export default createProjectState.reducer
